import * as React from "react";
import { useTranslation } from "react-i18next";
import useEntityTitles from "hooks/useEntityTitles";
import { Link, Spinner } from "components/common";
import { Table } from "components/bootstrap";
import { formatCount } from "components/inputs/helpers/InputThroughputUtils";
import Routes from "routing/Routes";
import useForwarderInputMetrics, { compositeIdFor } from "../../hooks/useForwarderInputMetrics";
const MessagesPerStreamSection = ({ input }) => {
  var _a;
  const { t } = useTranslation("enterprise_forwarder");
  const pair = { input_id: input.input_id, forwarder_node_id: input.forwarder_node_id };
  const { metricsByPair, isInitialLoading, isError } = useForwarderInputMetrics([pair], ["messages_per_stream"]);
  const messagesPerStream = (_a = metricsByPair[compositeIdFor(pair)]) == null ? void 0 : _a.messages_per_stream;
  const streamIds = messagesPerStream ? Object.keys(messagesPerStream) : [];
  const titleEntities = streamIds.map((id) => ({ id, type: "streams" }));
  const { titlesById, isInitialLoading: areTitlesLoading } = useEntityTitles(titleEntities);
  if (isInitialLoading && !messagesPerStream) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  if (isError) {
    return /* @__PURE__ */ React.createElement("p", null, t("messages_per_stream_section.load_error"));
  }
  if (!messagesPerStream || streamIds.length === 0) {
    return /* @__PURE__ */ React.createElement("p", null, t("messages_per_stream_section.no_messages"));
  }
  const sortedEntries = Object.entries(messagesPerStream).sort(([, a], [, b]) => b - a);
  return /* @__PURE__ */ React.createElement(Table, { bordered: true, condensed: true }, /* @__PURE__ */ React.createElement("thead", null, /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("th", null, t("messages_per_stream_section.stream_header")), /* @__PURE__ */ React.createElement("th", null, t("messages_per_stream_section.messages_header")))), /* @__PURE__ */ React.createElement("tbody", null, sortedEntries.map(([streamId, count]) => {
    const title = titlesById[streamId];
    const label = title != null ? title : areTitlesLoading ? streamId : t("common.deleted_stream", { id: streamId });
    return /* @__PURE__ */ React.createElement("tr", { key: streamId }, /* @__PURE__ */ React.createElement("td", null, title ? /* @__PURE__ */ React.createElement(Link, { to: Routes.stream_view(streamId) }, label) : label), /* @__PURE__ */ React.createElement("td", null, formatCount(count)));
  })));
};
export default MessagesPerStreamSection;
